import { useQuery } from "@tanstack/react-query";
import { PatientV2Service } from "../services/PatientV2Service";
function lookupKey(lookup) {
    if (lookup.channel === "email") {
        return lookup.email ? `email:${lookup.email}` : null;
    }
    return lookup.countryCode && lookup.phoneNumber
        ? `phone:${lookup.countryCode}${lookup.phoneNumber}`
        : null;
}
export function usePatientsQuery(params) {
    const { lookup, enabled, bookingRevision } = params;
    const key = lookupKey(lookup);
    return useQuery({
        queryKey: ["medos", "patients", key, bookingRevision],
        queryFn: () => PatientV2Service.searchByPhone(lookup),
        enabled: enabled && !!key,
        staleTime: 2 * 60 * 1000,
        gcTime: 5 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });
}
